export const initialState = {
  fetched: false,
  data: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'USER_BEHAVIOR_FETCHED':
      return {
        ...state,
        fetched: true,
        ...action.payload,
      };
    default:
      return state;
  }
}
